import ApexCharts, { ApexOptions } from 'apexcharts'
import React, { useEffect, useMemo, useRef } from 'react'
import { getCSS } from '../../../../../_metronic/assets/ts/_utils'
import { useThemeMode } from '../../../../../_metronic/partials'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { useGetJobTitle } from '../../core/_query'
import { DashboardJobTitle } from '../../core/_models'
import LoadingChart from '@/app/modules/apps/dashboard/components/LoadingChart'

type Props = {
  className: string
  title?: string
}

const JobTitlePieChart: React.FC<Props> = ({ className, title }) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const { mode } = useThemeMode()
  const { state } = useQueryRequest()
  const { data: jobData, isLoading } = useGetJobTitle(state)

  const jobTitles = useMemo(() => {
    return jobData?.response?.data
  }, [jobData])

  const refreshMode = () => {
    if (!chartRef.current) {
      return
    }

    const height = parseInt(getCSS(chartRef.current, 'height'))

    const chart = new ApexCharts(chartRef.current, getChartOptions(height, jobTitles))
    if (chart) {
      chart.render()
    }

    return chart
  }

  useEffect(() => {
    const chart = refreshMode()

    return () => {
      if (chart) {
        chart.destroy()
      }
    }
  }, [chartRef, mode, jobTitles])

  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3'>{title}</span>
        </h3>
      </div>
      {/* end::Header */}

      {/* begin::Body */}
      <div className='card-body'>
        {isLoading && <LoadingChart />}
        {jobData === null && <label className='form-label'>no result data</label>}
        {!isLoading && (
          <div ref={chartRef} id='kt_charts_widget_3_chart' style={{ height: '290px' }}></div>
        )}
      </div>
      {/* end::Body */}
    </div>
  )
}

export { JobTitlePieChart }

function getChartOptions(height: number, data: DashboardJobTitle[] | undefined): ApexOptions {
  let arrayOfSeries: any = []
  let arrayOfLabels: any = []
  if (data !== undefined) {
    arrayOfSeries = data?.map((obj) => (obj.total !== null ? obj.total : 0))
    arrayOfLabels = data?.map((obj) => (obj.job_title !== null ? obj.job_title : 'undefined'))
  }

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, '.')
  }

  // Generate a color for each item using HSL (Hue changes based on index)
  const generateColors = (count: number) => {
    return Array.from({ length: count }, (_, i) => `hsl(${(i * 360) / count}, 70%, 60%)`)
  }

  function generateDistinctColors(count: number): string[] {
    const colors: string[] = []
    const saturation = 65
    const lightness = 55
  
    for (let i = 0; i < count; i++) {
      const hue = Math.floor((360 / count) * i)
      colors.push(`hsl(${hue}, ${saturation}%, ${lightness}%)`)
    }
  
    return colors
  }
  

  return {
    series: arrayOfSeries,
    chart: {
      // width: 380,
      type: 'pie',
    },
    labels: arrayOfLabels,
    colors: generateDistinctColors(arrayOfSeries.length), // Inject custom colors here
    legend: {
      position: 'top',
    },
    tooltip: {
      style: {
        fontSize: '12px',
      },
      // y: {
      //   formatter: function (val) {
      //     return 'Rp. ' + numberWithCommas()
      //   },
      // },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          // chart: {
          //   width: 200,
          // },
          legend: {
            position: 'bottom',
          },
        },
      },
    ],
  }
}
